<template>
    <div class="tabs mx-auto px-4 md:px-20">
        <div
            class="tab tab-lg tab-lifted"
            :class="{ 'tab-active text-sky-600': !showReserve }"
            @click="setShow(false)"
        >
            Hírek
        </div>
        <div
            class="tab tab-lg tab-lifted"
            :class="{ 'tab-active text-sky-600': showReserve }"
            @click="setShow(true)"
        >
            Szobafoglalás
        </div>
    </div>
    <div v-show="!showReserve" class="grid gap-3 px-4 md:px-20">
        <div v-for="article in articles" class="article-card w-full dark:bg-base-300 shadow-xl">
            <div class="card-body">
                <h2 class="card-title">{{ article.title }}</h2>
                <div class="markdown-container" v-html="articleText(article)"></div>
                <div class="card-actions justify-end">
                    <div class="text-sm">{{ article.author }} - {{ article.created_at }}</div>
                </div>
            </div>
        </div>
    </div>
    <DormComponent v-show="showReserve" />
</template>

<script>
import DormComponent from '../user/DormComponent';
import { isNull } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { marked } from 'marked';

export default {
    name: 'HomeTab',
    components: { DormComponent },
    props: {
        reserve: {
            default: false,
            required: false,
        },
    },
    data() {
        return {
            showReserve: false,
        };
    },
    computed: {
        ...mapGetters('Article', ['articles']),
    },
    mounted() {
        this.getArticlesAsync();
        if (this.reserve) {
            this.showReserve = true;
            return;
        }
        if (!isNull(localStorage.getItem('showReserve'))) {
            this.showReserve = localStorage.getItem('showReserve') === 'true';
        }
    },
    methods: {
        ...mapActions('Article', ['getArticlesAsync']),
        setShow(reserve) {
            localStorage.setItem('showReserve', reserve);
            this.showReserve = reserve;
        },
        articleText(article) {
            return marked(article?.body || '');
        },
    },
};
</script>

<style scoped>
</style>
